import { render, staticRenderFns } from "./AcceptTCsModal.vue?vue&type=template&id=bf41adb6"
import script from "./AcceptTCsModal.vue?vue&type=script&lang=js"
export * from "./AcceptTCsModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptTCsModal.vue?vue&type=style&index=0&id=bf41adb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports